


import React, { Component } from "react"
import Audit from "../../Common/audit"
import Field from "../../Common/Field/Field"
import Async from "react-select"
import { PermissionServices } from "../../../services"
import moment from "moment"
import "./index.css"
import { withRouter } from "react-router-dom"

  class ModuleHeader extends Component {
  state = {
    assignedToList: []
    // statusOption: [
    //   { label: "CANCEL", value: "CANCEL" },
    //   { label: "COMPLETED", value: "COMPLETED" },
    //   { label: "IN PROCESS", value: "INPROCESS" },
    //   { label: "PENDING", value: "PENDING" }
    // ]
  }

  componentWillMount() {
    this.searchEmpList("")
    const { process, disabled } = this.props
    this.setState({
      process,
      disabled
    })
  }

  componentWillReceiveProps(nextProps) {
    // this.searchEmpList("")
    const { process, disabled } = nextProps
    this.setState({
      process,
      disabled
    })
  }

  // componentDidMount() {
  //   this.searchEmpList("")
  // }

  searchEmpList = value => {
    PermissionServices.searchEmploye(value).then(async res => {
      if (res.status == 200) {
        this.setState({ assignedToList: await res.text.data })
      }
    })
  }

  render() {
    const { assignedTo, status, ETA, processDate } = this.state.process
    const { placeOfSewing, statusList, measurementModal,generatePDF } = this.props

    return (
      <div className="flex-head">
        <div className="flex-grow">
          <h6 class="dev-title" style={{ paddingBottom: "10px" }}>
            <b>{this.props.header}</b>
          </h6>
        </div>
        <div className="p-1 d-flex justify-content-center align-items-center mt-2">
        <div className="">
              {measurementModal && (
              <button
              style={{
                padding: "3px 6px",
                backgroundColor: "#009688",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px"
              }}
              onClick={() =>
                this.props.history.push({
                  pathname: "/measurementChat",
                  state: { header: this.props.header, _id: this.props._id, customer: this.props.customer, customerDepartmentId: this.props.customerDepartmentId, type: this.props.type, magnumStyleId: this.props.magnumStyleId, action: this.props.location.state.action}
                })
              }
            >Measurement Chart</button>
            )}
            {
              generatePDF && (<button
              style={{
                padding: "3px 6px",
                backgroundColor: "#009688",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px"
              }}
              onClick={this.props.onGeneratePDF}
            >Generate PDF</button>)
            }
          </div>
        </div>
        <div className="p-1" style={{ width: "150px" }}>
          <div className="form-group">
            <label>Assigned To</label>
            <div class="custom-async-select">
              <Async
                name="assignedTo"
                value={assignedTo}
                onChange={value =>
                  this.props.updateModulesMain(
                    "assignedTo",
                    value,
                    this.props.moduleName
                  )
                }
                placeholder="Find AssignedTo"
                options={this.state.assignedToList}
                disabled={this.state.disabled}
              />
            </div>
          </div>
        </div>
        {placeOfSewing !== undefined && (
          <div className="p-1">
            <Field
              isFormGroup={true}
              inputType="select"
              inputName="placeOfSewing"
              value={
                placeOfSewing !== null || (this.props.PLACEOFSEWING && this.props.PLACEOFSEWING[0].value)
              }
              label={"Place of sewing"}
              options={this.props.PLACEOFSEWING || []}
              onChange={this.props.updateSewing}
              disabled={this.state.disabled}
            />
          </div>
        )}

        <div className="p-1">
          <Field
            isFormGroup={true}
            inputType="select"
            inputName="status"
            value={status}
            label="Status"
            options={statusList}
            onChange={(name, value) =>
              this.props.updateModulesMain(name, value, this.props.moduleName)
            }
            disabled={this.state.disabled}
          />
        </div>
        <div className="p-1">
          <Field
            durationETA={this.props.durationETA}
            isFormGroup={true}
            inputType="date"
            inputName="ETA"
            value={ETA}
            label={"ETA Date"}
            onChange={(name, value) =>
              this.props.updateModulesMain(name, value, this.props.moduleName)
            }
            disabled={this.state.disabled}
          />
        </div>
        <div className="p-1">
          {/* <Field
            isFormGroup={true}
            inputType="date"
            inputName="processDate"
            value={processDate}
            label={"Completed Date"}
            onChange={(name,value) => this.props.updateModulesMain(name,value,this.props.moduleName)}
            disabled={this.state.disabled}
          /> */}
          <div className="form-group">
            <label>Completed Date</label>
            {status == "COMPLETED" ? (
              <p>
                {processDate !== null
                  ? moment(processDate).format("DD MMM YYYY")
                  : ""}
              </p>
            ) : (
                ""
              )}
          </div>
        </div>
        <div className="p-1 m-1">
          <Audit _id={this.props._id} moduleName={this.props.moduleName === "qc" ? this.props.moduleName : this.props.header} />
        </div>
      </div>
    )
  }
}
export default withRouter(ModuleHeader);



// WEBPACK FOOTER //
// ./src/components/SampleRequest/ModuleHeader/index.js